import { PROJECT_VARIANTS } from '../../constants';
import * as storyActions from '../../redux/story/storyActions';
import * as storyStudioMediaActions from '../../redux/story/storyStudioMediaActions';

const storyActionsMapping = {
  initStory: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.storyInit,
  },
  getSession: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getSession,
  },
  searchSession: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.searchSession,
  },
  uploadStoryMedia: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.uploadStoryMedia,
  },
  searchMediaPool: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.searchMediaPool,
  },
  generateStory: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.generateStory,
  },
  searchGeneratedContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.searchGeneratedContent,
  },
  getUsedMedia: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getUsedMedia,
  },
  changePreview: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.changePreview,
  },
  reGenerateStoryContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.reGenerateStoryContent,
  },
  getMatchedStoryContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getMatchedStoryContent,
  },
  setStoryContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.setStoryContent,
  },
  sendStory: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.sendStory,
  },
  clearGeneratedContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.clearGeneratedContent,
  },
  getStoryMediaStudioPayload: {
    [PROJECT_VARIANTS.ADMIN]: storyStudioMediaActions.getStoryMediaStudioPayload,
    // [PROJECT_VARIANTS.CONSUMER]: consumerStoryActions.getStoryMediaStudioPayload,
  },
};

export default storyActionsMapping;
